import * as React from "react";
import { GlobalConnectedProps, withVariableLookup } from "components/form/VariableLookup/VariableLookup";
import { default as Text, TextProps } from "components/form/Text/Text";

const TextWithInputRef = (props: TextProps & GlobalConnectedProps) => <Text textInputRef={props.textInputRef} {...props} />;
export const VariableLookupText = withVariableLookup()(TextWithInputRef);
